import * as React from "react"

import { Icon, SemanticICONS } from "semantic-ui-react"

import "./index.css"

interface SocialLinkProps {
    link: string
    icon: SemanticICONS
    text: string
}

export default class SocialLink extends React.Component<SocialLinkProps> {
    render() {
        return (
            <div className="SocialLink">
                <a href={this.props.link}>
                    <Icon link name={this.props.icon} size="large"/>
                    {this.props.text}
                </a>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/frontpage/SocialLink/index.tsx